module.exports = __webpack_public_path__ + "static/media/shape.b6ad029d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instore/icons/shape.svg
// module id = 153
// module chunks = 0